import type { ReactElement } from "react";

import styles from "./Spinner.module.css";

export interface SpinnerProps {
  readonly label: string;
}

/**
 * A busy indicator that says what it is waiting for.
 *
 * `role="status"` with `aria-live="polite"` announces the label without
 * interrupting, and the label is rendered rather than hidden: a spinning ring
 * with no text tells a sighted reader nothing either.
 */
export function Spinner({ label }: SpinnerProps): ReactElement {
  return (
    <span className={styles.spinner} role="status" aria-live="polite">
      <span className={styles.circle} aria-hidden="true" />
      {label}
    </span>
  );
}
